import { Icon } from "@fluentui/react";
import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

type Props = {
  score: number;
};

export const ResultsScore = ({ score }: Props) => {
  const { t } = useTranslation();
  return (
    <Container>
      <StyledIcon iconName="CircleFill" />
      <ResultsLabel>{t("greco.searchResults")}</ResultsLabel>
      <ResultNumber>{score}</ResultNumber>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ResultsLabel = styled.div`
  font-size: 14px;
  color: ${(p) => p.theme.palette?.neutralPrimary};
  margin-right: 5px;
  @media (max-width: 800px) {
    display: none;
  }
`;

const ResultNumber = styled.div`
  font-size: 14px;
  color: ${(p) => p.theme.palette?.neutralPrimary};
`;

const StyledIcon = styled(Icon)`
  font-size: 8px;
  color: ${(p) => p.theme.palette?.themePrimary};
  margin-right: 8px;
`;
